var exports = {
  "t": "xe564cbfb--ed0cc2--adornment",
};

module.exports = exports;
